import { render, staticRenderFns } from "./TrainingInformation.vue?vue&type=template&id=24bd2adc&scoped=true&"
import script from "./TrainingInformation.vue?vue&type=script&lang=js&"
export * from "./TrainingInformation.vue?vue&type=script&lang=js&"
import style0 from "./TrainingInformation.vue?vue&type=style&index=0&id=24bd2adc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bd2adc",
  null
  
)

export default component.exports